import React, { Component } from "react";
import Chart from "react-apexcharts";

class GenricChart extends Component {
  constructor(props) {
    super(props);

    this.updateCharts = this.updateCharts.bind(this);
   
    if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
      this.state = {

      options: {
        chart:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['chart'],
        dataLabels:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['dataLabels'],
        xaxis:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['xaxis'],
        yaxis:{
          "labels": {
            "formatter": function (val) {
                return val.toFixed(2)
            }
          } 
        },
        legend: {
          show: this.props.prams.legend
        }
      },
      series:this.props.prams.filterData[this.props.prams.prams.kpiId]['series'],
      };
   }
  }
   componentDidUpdate(prevProps){
    
    if (this.props.prams.legend !== prevProps.prams.legend) {
      if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
         this.updateCharts();
      }
    }
   }

   
  updateCharts() {
    this.setState({
      options:{
         legend: {
          show: this.props.prams.legend
        }
      },
    });
  }

  render() {
    if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
      return (
        <div className='Polar'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='componentNameC'>{this.props.prams.prams.component}</div>
            </div>
          </div>
          <div className="p-4 Polar1" style={{paddingBottom:'3px'}}>
            <Chart
                options={this.state.options}
                series={this.state.series}
                height='100%'
                type={this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['chart']['type']}  />
              
          </div>
        </div>
      );
  }else{
  return (
    <div className='Polar'>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='componentNameC'>{this.props.prams.prams.component}</div>
        </div>
      </div>
      <div className="p-4 Polar1" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh', // Optionally set a height to center vertically in the viewport
        color: '#85929E'
      }}>
        Data Not Found!
      </div>

    </div>
  );
 }
}
}

export default GenricChart;
